import './bootstrap';
import {Tab, Modal} from 'bootstrap';
import jQuery from 'jquery';
import Cart from './cart/operations.js';
import initCombo from './cart/combo.js';
import PaymentStatusChecker from './payment/status-checker.js';
import PaymentButtons from './payment/payment-buttons.js';
import Toastify from 'toastify-js';
window.bootstrap = {};
window.bootstrap.Tab = Tab;
window.bootstrap.Modal = Modal;
window.Toastify = Toastify;
window.jQuery = window.$ = jQuery;
window.cart = Cart;
window.paymentChecker = PaymentStatusChecker;
window.paymentButtons = PaymentButtons;
window.number = new Intl.NumberFormat('es-UY', {
    style: 'currency',
    currency: 'UYU',
    currencyDisplay: 'symbol'
});
initCombo();
